export class LexbeCoding {
  fieldId: string;
  docId: string;
}
